export default __webpack_public_path__ + "static/media/dot.12ec6539.png";